import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/TaskTable";
import TaskTable from "../components/TaskTable";
import TaskDrawer from "../components/TaskDrawer";
import { Button } from "../components/ui/button";
import { Download } from "lucide-react";

const REPORTS = [
  ["all", "All Tasks"], ["open", "Open"], ["completed", "Completed"], ["overdue", "Overdue"],
  ["blocked", "Blocked"], ["due_today", "Due Today"], ["critical", "Critical"],
];

export default function Reports() {
  const [report, setReport] = useState("overdue");
  const [tasks, setTasks] = useState([]);
  const [openId, setOpenId] = useState(null);
  const load = () => api.get("/reports/tasks", { params: { report } }).then((r) => setTasks(r.data.tasks));
  useEffect(() => { load(); }, [report]);

  const exp = async (fmt) => {
    const res = await api.get("/export/tasks", { params: { fmt }, responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a"); a.href = url; a.download = `tasks.${fmt === "excel" ? "xlsx" : "csv"}`; a.click();
  };

  return (
    <div className="p-6">
      <PageHeader title="Report Center" subtitle="Task, department and management reports">
        <Button variant="outline" size="sm" onClick={() => exp("csv")}><Download size={14} className="mr-1" /> CSV</Button>
        <Button variant="outline" size="sm" onClick={() => exp("excel")}><Download size={14} className="mr-1" /> Excel</Button>
        <Button variant="outline" size="sm" onClick={() => window.print()}>Print / PDF</Button>
      </PageHeader>
      <div className="flex gap-2 mb-4 flex-wrap">
        {REPORTS.map(([k, l]) => (
          <button key={k} data-testid={`report-${k}`} onClick={() => setReport(k)}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium border ${report === k ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600"}`}>
            {l} ({report === k ? tasks.length : ""})
          </button>
        ))}
      </div>
      <TaskTable tasks={tasks} onOpen={setOpenId} />
      {openId && <TaskDrawer taskId={openId} onClose={() => setOpenId(null)} onChanged={load} />}
    </div>
  );
}
